module.exports = __webpack_public_path__ + "img/particle_motion_00074.89087c4c.png";